export const formatDate = (dateString) => {
  const date = new Date(dateString);

  const options = {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    weekday: 'long',
    timeZone: 'America/Chicago'
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  return `${formattedDate}`;
};


export const formatDateLong = (dateString) => {
  const date = new Date(dateString);

  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'America/Chicago',
    daySuffix: 'numeric'
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  return formattedDate;
};

export const formatDateShort = (dateString) => {
  const date = new Date(dateString);

  const options = {
    month: 'numeric',
    day: 'numeric',
    timeZone: 'America/Chicago',
    daySuffix: 'numeric'
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  return formattedDate;
};


export const formatDateWeekday = (dateString) => {
  const date = new Date(dateString);

  const options = {
    weekday: 'long',
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  return formattedDate;
};

export const formatTime = (timeString) => {
  const [hours, minutes] = timeString.split(':');
  let period = 'AM';
  let formattedHours = parseInt(hours, 10);

  if (formattedHours === 0) {
    formattedHours = 12;
  } else if (formattedHours === 12) {
    period = 'PM';
  } else if (formattedHours > 12) {
    formattedHours -= 12;
    period = 'PM';
  }

  return `${formattedHours}:${minutes} ${period}`;
};



export const formatDayAndDate = (dateString) => {
  const date = new Date(dateString);
  return formatDateLong(date) + ' - ' + formatDateWeekday(date);
};

export const formatDay = (dateString) => {
  const date = new Date(dateString);
  return formatDateShort(date) + ' - ' + formatDateWeekday(date);
};


export const generateOrderIDs = (date, ordersCount) => {
  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const orderIDs = [];

  const parsedDate = new Date(date);
  const dayOfWeek = parsedDate.getDay(); // 0 (Sunday) to 6 (Saturday)
  const prefix = dayOfWeek === 0 ? 7 : dayOfWeek; // Adjusted to start from 1 instead of 0

  for (let i = 0; i < ordersCount; i++) {
    const suffix = String.fromCharCode(65 + i); // 'A' = 65 in ASCII, 'B' = 66, etc.
    const orderID = `${prefix}${suffix}`;
    orderIDs.push(orderID);
  }

  return orderIDs;
};


export const PrettyPrintJson = ({ data }) => (<div><pre>{
  JSON.stringify(data, null, 2)}</pre></div>);

function getNextOrderID(date, existingOrdersCount) {
  const parsedDate = new Date(date);
  const dayOfWeek = parsedDate.getDay(); // 0 (Sunday) to 6 (Saturday)
  const prefix = dayOfWeek === 0 ? 7 : dayOfWeek; // Adjusted to start from 1 instead of 0
  const nextOrderID = `${prefix}${String.fromCharCode(65 + existingOrdersCount)}`; // Corrected the calculation
  return nextOrderID;
}

const date = '08/27/23';
const existingOrdersCount = 5;
const nextOrderID = getNextOrderID(date, existingOrdersCount);
// console.log("Order ID DEMO:", nextOrderID); // Output: 1E
// console.log("date:", date);


export const formatToUSD = (value) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(value);
}


const calculateCakeServings = (cake, productProperties) => {
  let totalServings = 0;

  if (!productProperties || !productProperties[0].shapes) {
    return totalServings;
  }

  cake.tiers.forEach(tier => {
    // Check if the flavor is a variation of "Faux"
    if (tier.flavor && tier.flavor.toLowerCase() === 'faux') {
      // If it is, the servings for this tier are 0
      return;
    }

    let shapeData = productProperties[0]?.shapes[tier?.shape];
    if (shapeData) {
      let sizeData = shapeData?.find(sizeObj => parseInt(sizeObj.size) === parseInt(tier.size));
      if (sizeData) {
        let layerData = sizeData?.layers?.find(layerObj => parseInt(layerObj.layerCount) === parseInt(tier.layers));
        if (layerData) {
          totalServings += layerData.servings;
        }
      }
    }
  });

  return totalServings;
};

//Bakery Tool Specific Utils
export const generateOrderDescription = (orderItems, productProperties) => {

  const getTieredDescription = (numberOfTiers) => {
    const tierDescriptions = {
      1: "Single",
      2: "Double tiered",
      3: "Triple tiered",
      4: "Four tiered",
      5: "Five tiered",
      6: "Six tiered",
      7: "Seven tiered",
      8: "Eight tiered",
      9: "Nine tiered",
      10: "Ten tiered",
      11: "Eleven tiered",
      12: "Twelve tiered",
      // ... and so on up to 12.
    };
    return tierDescriptions[numberOfTiers] || `${numberOfTiers} tiered`;
  };


  let descriptionList = [];

  // Helper function to add items to descriptionList if they have content
  const addIfContent = (content) => {
    if (content && content.trim()) descriptionList.push(content);
  }

  // Cakes
  orderItems?.cakes?.forEach(cake => {
    let cakeServings = calculateCakeServings(cake, productProperties);
    let batterOuncesObj = calculateCakeBatterOunces(cake, productProperties);

    const cakeOunces = Object.entries(batterOuncesObj)
      .map(([flavor, ounces]) => `•${flavor}: ${ounces}oz`)
      .join('\n');

    const tiersDescription = cake.tiers.map(tier => {
      const flavor = tier.flavor ? tier.flavor.toLowerCase() : 'unknown flavor';
      // Check for 'faux' flavor
      if (flavor === 'faux') {
        // Return simplified description for 'faux' flavored tiers
        return `•${tier.size}" ${tier.shape.toLowerCase()} faux cake`;
      } else {
        // Return full description for regular flavored tiers
        return `•${tier.size}" ${tier.shape.toLowerCase()} ${flavor} cake with ${tier.soak ? tier.soak.toLowerCase() + ' soak,' : ''} ${tier.filling ? tier.filling.toLowerCase() + ' filling ' : ''}${tier.premiumFilling ? ' and ' + tier.premiumFilling.toLowerCase() + ' premium filling,' : ''} covered in ${tier.exteriorIcing ? tier.exteriorIcing.toLowerCase() : 'icing'}`;
      }
    }).join('\n');

    let cakeSummary = `== ${cake.description ? cake.description + ' Summary ==' : 'Cake #' + (orderItems.cakes.indexOf(cake) + 1) + ' Summary =='}
      ${cake.tiers.length === 1 ? cake.tiers[0].layers === 2 && parseInt(cake.tiers[0].size) === 6 ? 'Smash ' : getTieredDescription(cake.tiers.length) : getTieredDescription(cake.tiers.length)} cake for approximately ${cakeServings} servings made up of:
      ${tiersDescription}
      `
    // Approx Batter Ounces Required:
    // ${cakeOunces}`;

    addIfContent(cakeSummary);
    let toppers = describeToppers(cake.toppers);
    let decoratingItems = describeDecoratingItems(cake.decoratingItems);
    if (toppers?.length) addIfContent(toppers.join('\n'));
    toppers?.length && descriptionList.push("__NEWLINE__");
    if (decoratingItems?.length) addIfContent(decoratingItems.join('\n'));
    decoratingItems?.length && descriptionList.push("__NEWLINE__");
    let boardInscription = cake.boardInscription ? `- Board Inscription -
      ${cake.boardInscription}` : '';
    let specialInstructions = cake.specialInstructions ? `- Special Instructions -
      ${cake.specialInstructions}` : '';
    let tierInscriptions = cake.tiers.length >= 1 ?
      cake.tiers
        .map(tier => {
          if (tier.inscription && tier.inscription !== '') {
            return `${tier.size}" cake inscription: "${tier.inscription ? tier.inscription : ''}"`;
          }
          return null;
        })
        .filter(Boolean)
        .join(', and ')
      : '';

    addIfContent(boardInscription);
    boardInscription && boardInscription !== '' && descriptionList.push("__NEWLINE__");
    addIfContent(specialInstructions);
    specialInstructions && specialInstructions !== '' && descriptionList.push("__NEWLINE__");
    addIfContent(tierInscriptions);
    tierInscriptions && tierInscriptions !== '' && descriptionList.push("__NEWLINE__");
  });
  orderItems?.cakes?.length && descriptionList.push("__NEWLINE__");

  // Cookies
  if (orderItems.cookies.length) {
    descriptionList.push(`== Cookies ==`);
    orderItems.cookies.forEach(cookie => {
      descriptionList.push(`•${cookie.quantity} ${cookie?.flavor?.toLowerCase()} ${cookie?.shape?.toLowerCase()} cookies with  ${cookie?.icingColor?.toLowerCase()} ${cookie?.icing?.toLowerCase()} ${cookie.description ? ('- ' + cookie?.description) : ''} ${cookie?.price ? ' @$' + parseFloat(cookie?.price).toFixed(2) + 'ea' : ''}`);
      //descriptionList.push(`- ${cookie.quantity} ${cookie.flavor} ${cookie.shape} cookies with ${cookie.icing} icing of ${cookie.icingColor} color.`);
      if (cookie.toppers) descriptionList.push(...describeToppers(cookie.toppers));
      if (cookie.decoratingItems) descriptionList.push(...describeDecoratingItems(cookie.decoratingItems));
      //descriptionList.push(...describeBakingDecorating(cookie));
    });
    //descriptionList.push("");
    descriptionList.push("__NEWLINE__");
  }

  // Cupcakes
  if (orderItems.cupcakes.length) {
    descriptionList.push(`== Cupcakes ==`);
    orderItems.cupcakes.forEach(cupcake => {
      descriptionList.push(`•${cupcake.quantity} ${cupcake?.flavor?.toLowerCase()} cupcakes ${cupcake?.filling || cupcake?.finalIcingColor || cupcake?.finalIcing ? 'with' : ''} ${cupcake?.filling ? cupcake?.finalIcingColor || cupcake?.finalIcing ? cupcake?.filling.toLowerCase() + ' filling and' : cupcake?.filling.toLowerCase() + ' filling' : ''} ${cupcake?.finalIcingColor?.toLowerCase()} ${cupcake?.finalIcing?.toLowerCase()} ${cupcake.description ? ('- ' + cupcake?.description) : ''} ${cupcake?.price ? ' @$' + parseFloat(cupcake?.price).toFixed(2) + 'ea' : ''}`);
      //descriptionList.push(`- ${cupcake.quantity} ${cupcake.flavor} cupcakes with ${cupcake.finalIcing} icing of ${cupcake.finalIcingColor} color.`);
      if (cupcake.toppers) descriptionList.push(...describeToppers(cupcake.toppers));
      if (cupcake.decoratingItems) descriptionList.push(...describeDecoratingItems(cupcake.decoratingItems));
      //descriptionList.push(...describeBakingDecorating(cupcake));
    });
    //descriptionList.push("");
    descriptionList.push("__NEWLINE__");
  }

  // Check for types and count how many of each type there are
  let cakePopCount = 0;
  let cakeBallCount = 0;

  orderItems.cakePops.forEach(cakePop => {
    if (cakePop?.type?.toLowerCase() === 'cake pops') cakePopCount += cakePop.quantity;
    if (cakePop?.type?.toLowerCase() === 'cake balls') cakeBallCount += cakePop.quantity;
  });

  // Determine the header based on counts
  let header = '';
  if (cakePopCount > 0 && cakeBallCount > 0) {
    header = '== Cake Pops/Balls ==';
  } else if (cakePopCount > 0) {
    header = '== Cake Pops ==';
  } else if (cakeBallCount > 0) {
    header = '== Cake Balls ==';
  }


  // Cake Pops
  if (orderItems.cakePops.length) {
    descriptionList.push(header);
    orderItems.cakePops.forEach(cakePop => {
      descriptionList.push(`•${cakePop.quantity} ${cakePop?.flavor?.toLowerCase()} ${cakePop?.shape?.toLowerCase()} ${cakePop?.type !== '' && cakePop?.type ? cakePop?.type?.toLowerCase() + (cakePop?.orientation && cakePop?.orientation !== '' ? '(' + cakePop?.orientation?.toLowerCase() + ')' : '') : ' cake pops'} with ${cakePop?.coatingColor?.toLowerCase()} coating of chocolate. ${cakePop.description ? ('- ' + cakePop?.description) : ''} ${cakePop?.price ? ' @$' + parseFloat(cakePop?.price).toFixed(2) + 'ea' : ''}`);
      //descriptionList.push(`- ${cakePop.quantity} ${cakePop.flavor} ${cakePop.shape} cake pops with ${cakePop.chocolateCoating} coating of ${cakePop.coatingColor} color.`);
      if (cakePop.toppers) descriptionList.push(...describeToppers(cakePop.toppers));
      if (cakePop.decoratingItems) descriptionList.push(...describeDecoratingItems(cakePop.decoratingItems));
      //descriptionList.push(...describeBakingDecorating(cakePop));
    });
    //descriptionList.push("");
    descriptionList.push("__NEWLINE__");
  }

  // General Items
  if (orderItems.generalItems.length) {
    descriptionList.push(`== General Items ==`);
    orderItems.generalItems.forEach(item => {
      descriptionList.push(`•${item.quantity} ${item?.flavor?.toLowerCase()} ${item.item?.toLowerCase()} - ${item.description || ''} ${item?.price ? ' @$' + parseFloat(item?.price).toFixed(2) + 'ea' : ''}`);
      //descriptionList.push(`- ${item.quantity} ${item.flavor} ${item.item}. Notes: ${item.flavorNotes || "None"}`);
      if (item.toppers) descriptionList.push(...describeToppers(item.toppers));
      if (item.decoratingItems) descriptionList.push(...describeDecoratingItems(item.decoratingItems));
      //descriptionList.push(...describeBakingDecorating(item));
    });
    //descriptionList.push("");
    descriptionList.push("__NEWLINE__");
  }

  return descriptionList.filter(Boolean).join('\n').replace(/__NEWLINE__/g, '');

};



const calculateCakeBatterOunces = (cake, productProperties) => {
  let batterOuncesByFlavor = {};

  if (!productProperties || !productProperties[0].shapes) {
    return batterOuncesByFlavor;
  }

  cake.tiers.forEach(tier => {
    let shapeData = productProperties[0].shapes[tier.shape];
    if (shapeData) {
      let sizeData = shapeData?.find(sizeObj => parseInt(sizeObj.size) === parseInt(tier.size));
      if (sizeData) {
        let baseFlavor = getBaseFlavor(tier.flavor);
        if (sizeData.batterOunces && sizeData.batterOunces[baseFlavor]) {
          // Consider number of layers in the multiplication
          batterOuncesByFlavor[baseFlavor] = (batterOuncesByFlavor[baseFlavor] || 0) + sizeData.batterOunces[baseFlavor] * parseInt(tier.layers);
        }
      }
    }
  });

  return batterOuncesByFlavor;
};


const getBaseFlavor = (flavor) => {

  if (!flavor) return flavor;

  if (flavor.includes("Vanilla Bean") ||
    flavor.includes("Vanilla (Gluten Free)") ||
    flavor.includes("Vanilla Almond") || flavor.includes("Funfetti") ||
    flavor.includes("Cookies & Cream") || flavor.includes("Coconut") ||
    flavor.includes("Pineapple") || flavor.includes("Champagne") ||
    flavor.includes("Marble") || flavor.includes("Pina Colada") ||
    flavor.includes("Pistachio") || flavor.includes("Lemon") ||
    flavor.includes("Lemon Poppy Seed") || flavor.includes("Carrot") ||
    flavor.includes("Strawberry")) {
    return "Vanilla";
  }
  else if (flavor.includes("Triple Chocolate") || flavor.includes("Mexican Chocolate") || flavor.includes("Chocolate Chili")) {
    return "Chocolate";
  }
  else if (flavor.includes("Red Velvet")) {
    return "Red Velvet";
  }
  else {
    return flavor;
  }
}


function describeToppers(toppers) {
  if (!toppers?.length) return [];
  return [
    '- Toppers -',
    ...toppers.map(topper => `•${topper.type} ${topper.description}${topper?.price ? ' @$' + parseFloat(topper?.price).toFixed(2) : ''}`)
  ];
}

function describeDecoratingItems(decoratingItems) {
  if (!decoratingItems?.length) return [];
  return [
    '- Decoration Add-ons -',
    ...decoratingItems.map(item => `•${item.type} ${item.description}${item?.price ? ' @$' + parseFloat(item?.price).toFixed(2) : ''}`)
  ];
}

const describeBakingDecorating = (item) => {
  const baking = item.bakingDate ? `Baked on ${item.bakingDate} by ${item.assignedBaker}. Notes: ${item.bakingNotes || "None"}` : '';
  const decorating = item.decoratingDate ? `Decorated on ${item.decoratingDate} by ${item.assignedDecorator}. Notes: ${item.decoratingNotes || "None"}` : '';
  return [baking, decorating];
}